import { useQuery } from '@tanstack/react-query';
import { fetchGL, fetchPnL } from './api';

export const pnlKeys = {
  all: ['pnl'] as const,
  month: (start: string, end: string) => [...pnlKeys.all, 'month', start, end] as const,
  gl: (accountId: string, start: string, end: string) =>
    [...pnlKeys.all, 'gl', accountId, start, end] as const,
};

export function usePnLMonth(start: string, end: string, enabled: boolean) {
  return useQuery({
    queryKey: pnlKeys.month(start, end),
    queryFn: () => fetchPnL(start, end),
    enabled: enabled && !!start && !!end,
    staleTime: 1000 * 60 * 5,
  });
}

export function useGL(accountId: string | null, start: string, end: string) {
  return useQuery({
    queryKey: pnlKeys.gl(accountId ?? '', start, end),
    queryFn: () => fetchGL(accountId!, start, end),
    enabled: !!accountId && !!start && !!end,
    staleTime: 1000 * 60 * 5,
  });
}
